import type { Components } from '@mui/material';

export const MuiLink = (): Partial<Components> => ({
  MuiLink: {
    defaultProps: {
      underline: 'hover',
    },
  },
});
